import { Container } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSubWrapper, SectionWrapper } from '../../../Styles/style'
import Header from '../../Token/Components/Header'
import StyledTable from './Components/Table'

const S1_Roadmap = () => {
    return (
        <div>
            <Header heading="Development Timeline" para="Representation Of A Period Of Time, On Which Important Events Are Marked" />
            <SectionSubWrapper p="4rem 0">    
            <Container maxWidth="xl">
                <SectionHeading p="30px 0" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="300"
                                data-aos-offset="0"
                                data-aos-duration="500">Roadmap</SectionHeading>
                <P p="0 0 30px" m="0" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-offset="0"
                                data-aos-duration="500">A Roadmap That Delivers Instant Functionality, With More To Come.</P>
                <StyledTable/>
            
            </Container>
            </SectionSubWrapper>
        </div>
    )
}

export default S1_Roadmap